import React from 'react';
import { GenericListPage } from '../../components/generic';
import type { EmbeddedInConfigurationHub } from '../configuration-settings/models';
import { CustomField, useCustomFieldsForManagement } from './useData';
import { moduleConfig, getColumns, getToolbarIcon, getTableActions } from './config';

const List: React.FC<EmbeddedInConfigurationHub> = ({ embedded }) => {
  const useCustomFieldsList = () => {
    const { data, isLoading, mutate } = useCustomFieldsForManagement();
    return {
      data,
      isLoading,
      mutate,
    };
  };

  return (
    <div className={embedded ? undefined : 'flex h-full min-h-0 flex-col'}>
      <div className={embedded ? undefined : 'min-h-0 flex-1 overflow-hidden'}>
        <GenericListPage<CustomField>
          useData={useCustomFieldsList}
          embedded={embedded}
          config={{
            ...moduleConfig,
            getColumns,
            getToolbarIcon,
            getTableActions,
          }}
        />
      </div>
    </div>
  );
};

export default List;
